// extracted by mini-css-extract-plugin
export default {"contentWrapper":"FullPageCardContent_contentWrapper__7pVBh","content":"FullPageCardContent_content__Dad79","layoutContent":"FullPageCardContent_layoutContent__Jvhmc"};